"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheManager = void 0;
class CacheManager {
    constructor(cacheKey, storageType, duration) {
        this.storage = storageType === 'localStorage' ? localStorage : sessionStorage;
        this.cacheKey = cacheKey;
        this.duration = duration;
    }
    parseDuration() {
        if (this.duration.type !== 'time') {
            throw new Error('Duration type is not "time"');
        }
        const unit = this.duration.value.slice(-1);
        const value = parseInt(this.duration.value.slice(0, -1), 10);
        const now = new Date();
        switch (unit) {
            case 'm': // minutes
                return now.getTime() + value * 60 * 1000;
            case 'h': // hours
                return now.getTime() + value * 60 * 60 * 1000;
            case 'd': // days
                return now.getTime() + value * 24 * 60 * 60 * 1000;
            case 'y': // years
                return now.getTime() + value * 365 * 24 * 60 * 60 * 1000;
            default:
                throw new Error(`Unsupported duration format: ${this.duration.value}`);
        }
    }
    getMidnightTime() {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0); // Set to midnight of the next day
        return midnight.getTime();
    }
    isExpired(expirationTime) {
        return new Date().getTime() > expirationTime;
    }
    setCache(value) {
        let expirationTime;
        if (this.duration.type === 'today') {
            expirationTime = this.getMidnightTime();
        }
        else if (this.duration.type === 'time') {
            expirationTime = this.parseDuration();
        }
        else {
            throw new Error(`Unsupported duration type: ${this.duration}`);
        }
        const expirationString = new Date(expirationTime).toLocaleString();
        const cacheData = {
            value,
            expirationTime,
            expirationString
        };
        this.storage.setItem(this.cacheKey, JSON.stringify(cacheData));
    }
    getCache() {
        const cacheDataString = this.storage.getItem(this.cacheKey);
        if (cacheDataString) {
            const cacheData = JSON.parse(cacheDataString);
            if (this.isExpired(cacheData.expirationTime)) {
                this.removeCache();
                return null;
            }
            return cacheData.value;
        }
        return null;
    }
    removeCache() {
        this.storage.removeItem(this.cacheKey);
    }
}
exports.CacheManager = CacheManager;
